import React from 'react'
import PropTypes from 'prop-types'
import { ACCEPTED_VIDEO_FORMATS_REGEX } from 'shared/constants'
import { SmartVideo } from 'shared/UI/SmartVideo'
import { SmartImage } from 'shared/UI/SmartImage'
import { HEIGHTS, WIDTH } from './constants'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

class Background extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      height: HEIGHTS[props.config.height],
      width: window.innerWidth
    }
  }

  getImageConfig = () => {
    const image = this.props.config.image
    const gravity = get(image.transformation, 'gravity', null)

    return {
      ...image,
      transformation: {
        ...image.transformation,
        quality: 'sensitive',
        gravity: isEmpty(gravity) ? {} : {
          ...gravity,
            height: this.state.height,
            width: this.state.width
        }
      }
    }
  }

  render = () => {

    const imageUrl = get(this.props, 'config.image.url', null)
    if (!imageUrl) {
      return null
    }

    const isVideo = new RegExp(ACCEPTED_VIDEO_FORMATS_REGEX).test(imageUrl)
    const SpecificRenderer = isVideo ? SmartVideo : SmartImage

    return (
      <div className="banner-media-container">
        <SpecificRenderer
          config={this.getImageConfig()}
          className="banner-background" />
      </div>
    )
  }
}

Background.propTypes = {
  config: PropTypes.object.isRequired
}

export default Background
